import * as React from 'react';

export type RadioButtonV2Props = Omit<
	React.InputHTMLAttributes<HTMLInputElement>,
	'type' | 'value'
> & {
	label: string;
	value: string;
	disabled?: boolean;
};

export const RadioButtonV2 = React.forwardRef<HTMLInputElement, RadioButtonV2Props>(
	({ label, value, disabled = false, ...props }, ref) => (
		<label className={`mr-4 ${disabled ? 'opacity-25' : ''}`}>
			<input
				className='mr-2 mb-1'
				ref={ref}
				type='radio'
				value={value}
				disabled={disabled}
				{...props}
			/>
			{label}
		</label>
	)
);
